import { createReducer } from "../reducerUtil"
import {
  ADD_DIE,
  REMOVE_DIE,
  DIE_TYPES,
  UPDATE_DICE_COLOR,
  SET_DICE,
  UPDATE_DICE_COUNTS,
  HANDLE_SWITCH_MODE,
  // SAVE_MULTI_MODE_STATE,
  // RESTORE_MULTI_MODE_STATE,
} from "./constants"
import seedrandom from "seedrandom"

const mathRandom = seedrandom()
const createDiceSetState = (color = "#D7D7D7", dieColor = "#ff6f3c") => ({
  diceCounts: {
    [DIE_TYPES.D4]: 0,
    [DIE_TYPES.D6]: 1,
    [DIE_TYPES.D8]: 0,
    [DIE_TYPES.D10]: 0,
    [DIE_TYPES.D12]: 0,
    [DIE_TYPES.D20]: 0,
    [DIE_TYPES.D100]: 0,
  },
  color,
  dice: [
    {
      id: 0,
      position: { x: 0, y: 0, z: -10 },
      rotation: { x: 0, y: 0, z: 0 },
      result: null,
      startRot: {
        x: mathRandom() * Math.PI * 2,
        y: mathRandom() * Math.PI * 2,
        z: mathRandom() * Math.PI * 2,
      },
      targetRot: { x: 0, y: 0, z: 0 },
      startPos: { x: 0, y: 0, z: -10 },
      targetPos: { x: 0, y: 0, z: -10 },
      isNew: false,
      type: "D6",
      globalRolling: false,
      singleRolling: false,
      showResult: false,
      color: dieColor,
    },
  ],
})

const initialState = {
  diceset: {
    ...createDiceSetState("#D7D7D7", "#ff6f3c"),
    currentMode: "d6",
  },
  daduset: {
    ...createDiceSetState("#D7D7D7", "#ff6f3c"),
    currentMode: "d6",
  },
}

const addDie = (state, payload) => {
  const { setKey, dieType } = payload
  return {
    ...state,
    [setKey]: {
      ...state[setKey],
      diceCounts: {
        ...state[setKey].diceCounts,
        [dieType]: state[setKey].diceCounts[dieType] + 1,
      },
    },
  }
}

const removeDie = (state, payload) => {
  const { setKey, dieType } = payload
  return {
    ...state,
    [setKey]: {
      ...state[setKey],
      diceCounts: {
        ...state[setKey].diceCounts,
        [dieType]: Math.max(0, state[setKey].diceCounts[dieType] - 1),
      },
    },
  }
}

const updateDiceColor = (state, payload) => {
  const { setKey, color } = payload
  return {
    ...state,
    [setKey]: {
      ...state[setKey],
      color,
    },
  }
}

const setDice = (state, payload) => {
  const { setKey, dice } = payload
  return {
    ...state,
    [setKey]: {
      ...state[setKey],
      dice,
    },
  }
}

const updateDiceCounts = (state, payload) => {
  const { setKey, dice } = payload
  const newDiceCounts = {
    [DIE_TYPES.D4]: 0,
    [DIE_TYPES.D6]: 0,
    [DIE_TYPES.D8]: 0,
    [DIE_TYPES.D10]: 0,
    [DIE_TYPES.D12]: 0,
    [DIE_TYPES.D20]: 0,
    [DIE_TYPES.D100]: 0,
  }

  const diceSetToCount = dice || state[setKey].dice
  diceSetToCount.forEach(die => {
    if (newDiceCounts.hasOwnProperty(die.type)) {
      newDiceCounts[die.type]++
    }
  })

  return {
    ...state,
    [setKey]: {
      ...state[setKey],
      diceCounts: newDiceCounts,
    },
  }
}

const handleSwitchMode = (state, payload) => {
  const { setKey, mode } = payload
  return {
    ...state,
    [setKey]: {
      ...state[setKey],
      currentMode: mode,
    },
  }
}

// const saveMultiModeState = state => {
//   return {
//     ...state,
//     savedMultiModeState: {
//       dice: state.dice.map(die => ({
//         type: die.type,
//         color: die.color,
//         id: die.id,
//       })),
//       diceCounts: { ...state.diceCounts },
//       color: state.color,
//     },
//   }
// }

// const restoreMultiModeState = state => {
//   if (!state.savedMultiModeState) {
//     return state
//   }

//   const restoredDice = state.savedMultiModeState.dice.map(savedDie => ({
//     id: savedDie.id,
//     position: { x: 0, y: 0, z: -10 },
//     rotation: { x: 0, y: 0, z: 0 },
//     result: null,
//     startRot: {
//       x: mathRandom() * Math.PI * 2,
//       y: mathRandom() * Math.PI * 2,
//       z: mathRandom() * Math.PI * 2,
//     },
//     targetRot: { x: 0, y: 0, z: 0 },
//     startPos: { x: 0, y: 0, z: -10 },
//     targetPos: { x: 0, y: 0, z: -10 },
//     isNew: false,
//     type: savedDie.type,
//     globalRolling: false,
//     singleRolling: false,
//     showResult: false,
//     color: savedDie.color,
//   }))

//   return {
//     ...state,
//     dice: restoredDice,
//     diceCounts: { ...state.savedMultiModeState.diceCounts },
//     color: state.savedMultiModeState.color,
//   }
// }

export default createReducer(initialState, {
  [ADD_DIE]: addDie,
  [REMOVE_DIE]: removeDie,
  [UPDATE_DICE_COLOR]: updateDiceColor,
  [SET_DICE]: setDice,
  [UPDATE_DICE_COUNTS]: updateDiceCounts,
  [HANDLE_SWITCH_MODE]: handleSwitchMode,
  // [SAVE_MULTI_MODE_STATE]: saveMultiModeState,
  // [RESTORE_MULTI_MODE_STATE]: restoreMultiModeState,
})
